module.exports = __webpack_public_path__ + "static/sword_of_life_stealing-5f4fe83a3b14e4f4483c68fb026bc283.jpeg";